import { inject, Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import type { SeatKind } from '@tellent/types';
import { shareReplay } from 'rxjs';

import { filterDefined } from '@recruitee/common';
import { fetchIfNotLoaded } from '@recruitee/ngrx';

import { TellentAppsActions, TellentAppsSelectors } from './tellent-apps.store';

@Injectable({
  providedIn: 'root',
})
export class TellentAppsDataService {
  public store = inject(Store);

  public apps$ = this.store.pipe(
    this.fetchIfNotLoaded(),
    select(TellentAppsSelectors.allEntities),
    filterDefined,
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  public getAppBySeatKind(kind: SeatKind) {
    return this.store.pipe(
      this.fetchIfNotLoaded(),
      select(TellentAppsSelectors.selectAppBySeatKind(kind)),
      filterDefined,
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  private fetchIfNotLoaded() {
    return fetchIfNotLoaded(this.store.select(TellentAppsSelectors.meta()), () =>
      this.store.dispatch(TellentAppsActions.fetchCollection()),
    );
  }
}
